import { Role, UserRight } from "../core/models/User";


const adminRole: Role = {
    title: 'Admin',
    userRights: UserRight.canCreatePost |
        UserRight.canDeletePost |
        UserRight.canUpdatePost |
        UserRight.canComment |
        UserRight.canUpdateComment |
        UserRight.canDeleteComment |
        UserRight.canLike |
        UserRight.canDislike |
        UserRight.canCreateUsers |
        UserRight.canUpdateUsers |
        UserRight.canDeleteUsers |
        UserRight.canDeleteOthersComments |
        UserRight.canDeleteOthersPosts |
        UserRight.canDeleteOthersLikes |
        UserRight.canDeleteOthersDislikes |
        UserRight.canSeeAllLikes |
        UserRight.canSeeAllDislikes |
        UserRight.canUpdatePortfolio |
        UserRight.canUpdateResume |
        UserRight.canUpdateContactMe |
        UserRight.canSeeAdminPanel |
        UserRight.zahra
}

const userRole: Role = {
    title: 'User',
    userRights: UserRight.canComment |
        UserRight.canUpdateComment |
        UserRight.canDeleteComment |
        UserRight.canLike |
        UserRight.canDislike
}

const zahraRole : Role = {
    title: 'Zahra',
    userRights: UserRight.canComment |
        UserRight.canUpdateComment |
        UserRight.canDeleteComment |
        UserRight.canLike |
        UserRight.canDislike |
        UserRight.canSeeAdminPanel |
        UserRight.zahra
}

export { adminRole, userRole, zahraRole };
